<template>
  <div class="screen-container panel-components">
    <div class="text-center item-carousel max-w-357 mx-auto">
      <div class="logo-icon">
        <img :src="image" alt="" />
      </div>
      <h3 class="mt-6">{{ text }}</h3>
      <p v-html="content"></p>
      <div v-if="showProgressState" class="max-w-357 center">
        <v-progress-linear
          color="#4F46E5"
          buffer-value="100"
          :value="progress"
          height="18"
          backgroundColor="#E9E9E9"
          align-items-center="True"
        >
          <template v-slot:default="{ value }">
            {{ Math.ceil(value) }}%
          </template>
        </v-progress-linear>
      </div>
      <div v-if="submit" class="start-btn mt-10">
        <v-btn elevation="0" height="40" @click="calibrateHandler"
          >Let’s Calibrate</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewEmptyState',
  props: {
    image: [String, Object],
    progress: [String, Number],
    showProgressState: Boolean,
    text: String,
    content: String,
    submit: Boolean,
  },

  methods: {
    calibrateHandler() {
      this.$emit('calibrate');
    },
  },
};
</script>
